module.exports = __webpack_public_path__ + "img/adobe-xd.5ab88f48.png";